import React from "react";
import uuidv4 from "uuid/v4";
import _get from "lodash-es/get";
import { Close2Hoc, InfoHoc, loaderSVG, SendMessageHoc } from "../../../../assets/images";
import { NO_RESULTS_FOUND, REACT_APP_XMPP_SOCKET_HOST } from "../../../../processENV.js";
import Users from "./Users";
import {
  // compare,
  // constructedActiveChatData,
  getMessageObjForward,
  getRecentChatMsgObjForward,
  getUserIdFromJid,
  getValidSearchVal,
  handleFilterBlockedContact,
  // updateUnreadCountObj,
} from "../../../../Helpers/Utility";
import {
  getContactNameFromRoster,
  getDataFromRoster,
  // getDataFromRoster,
  getUserInfoForSearch,
  isSingleChatJID,
} from "../../../../Helpers/Chat/User";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import { store } from "../../../../Redux/store";
import RecentSearch from "../../RecentChatSection/RecentSearch";
import SDK from "../../../../SDK";
import { updateRecentChat } from "../../../../Redux/feature/recentChatDataSlice";
import { addActiveChatData } from "../../../../Redux/feature/activeChatDataSlice";
import { 
  getChatHistoryMessagesData, 
  getMessageFromHistoryById,
//  handleTempArchivedChats,
} from "../../../../Helpers/Chat/ChatHelper";
import { addChatConversationHistory } from "../../../../Redux/feature/chatConversationHistorySlice";
import { addPendindMedia } from "../../../../Redux/feature/pendingMediaSlice";
import { NO_INTERNET } from "../../../../Helpers/Constants";
import { getUsersListFromSDK } from "../../RecentChatSection/userLists";
import { toast } from "react-toastify";
import { CHAT_TYPE_SINGLE } from "../../../../Helpers/Chat/Constant";

const ForwardPopUp = (props) => {
  const globalState = useSelector((state) => state);
  const { recentChatData, selectedMessageData,appOnlineStatus : {isAppOnline}, blockedContact, recentChatItems } = globalState
  const [forwardContact, setForwardContact] = React.useState({userLister: []})
  const {userLister} = forwardContact;
  const [filteredRecentChat, setfilteredRecentChat] = React.useState([])
  const [forwardPopUpState, setForwardPopUpState] = React.useState({
    searchValue: "",
    jidArray: [],
    contactsToForward: [],
    contactsToDisplay: [],
    filteredContacts: [],
    // filteredRecentChat: [],
    unBlockedUserName: [],
    loaderStatus: !globalState?.rosterData?.isFetchingUserList,
    // userList: [],
    isContactFetch:false
  });

  const {
    searchValue,
    jidArray,
    contactsToForward,
    contactsToDisplay,
    filteredContacts,
    // filteredRecentChat,
    unBlockedUserName,
    loaderStatus,
    // userList,
    isContactFetch
  } = forwardPopUpState;

  const {
    // closePopup = () => { },
    rosterData = {},
    // recentChatData = {},
    // selectedMessageData = {},
    // blockedContact = {},
    // groupsData = {},
    scrollToBottom = () => { },
    closeMessageOption
  } = props || {};

  React.useEffect(()=>{
    // store.dispatch(setInitialRoster())
    getUsersListFromSDK(1,"")
  },[])

  React.useEffect(() => {
    initialLoad(getValidSearchVal(searchValue), getValidSearchVal(searchValue));
  }, []);

  React.useEffect(() => {	
    initialLoad(getValidSearchVal(searchValue), getValidSearchVal(searchValue));	
  }, [isAppOnline]);	

  React.useEffect(() => {            	
    fetchMoreData();  	
  }, [isAppOnline]);

  React.useEffect(() => {	
    const updatedList = recentChatSearchFilter(getValidSearchVal(searchValue)).filter(item => (item?.roster?.isAdminBlocked !== true && item?.roster?.isDeletedUser !== true && item?.recent?.profileUpdatedStatus !== "userLeft"));
    setfilteredRecentChat(updatedList)
  }, [recentChatItems]);	

  React.useEffect(() => {
    let data = (globalState.rosterData && globalState.rosterData.data) || []
    if(!globalState.rosterData?.initialRosterFetched || !globalState.rosterData?.isFetchingUserList){
        getUsersListFromSDK(1,"")
        handleUpdateRoster(data, globalState.rosterData?.isFetchingUserList);
    }
  }, []);
  
  React.useEffect(() => {
    handleUpdateRoster(globalState.rosterData.data, globalState.rosterData?.isFetchingUserList);
  }, [globalState.rosterData])

  const handleUpdateRoster = (rosterDataUpdate, isFetchingUserList = false) => {
    let searchWithUpdate = forwardPopUpState.searchValue;
    let filteredData = handleFilterBlockedContact(rosterDataUpdate).filter(function (item) {
        let filterVariable = getContactNameFromRoster(item) || item.userId;
        return (item.isFriend) && filterVariable.toLowerCase().search(searchWithUpdate.toLowerCase()) !== -1;
    });
    let data = filteredData;
    setForwardContact({...forwardContact, userLister:data,loaderStatus: isFetchingUserList})
    setForwardPopUpState({...forwardPopUpState,filteredContacts: data, loaderStatus: isFetchingUserList})
  }
  /**
  // let latestSearchText = "";
  // let totalPages = 0;

  // const getUsersListSDK= async (pageNumber = 1, searchText = "")=> {
  //   latestSearchText = searchText;
  //   const response = await SDK.getUsersList(searchText, pageNumber, 20);
  //   // console.log(response,"response")
  //   if (searchText === latestSearchText) {
  //     if (response.statusCode === 200) {
  //           // totalPages = response.totalPages;
  //           let friends = response.users.map(user => {
  //             return {
  //                 ...user,
  //                 isFriend: true,
  //                 isDeletedUser: false
  //             }
  //           });
  //           let contacts = friends.sort(compare);
  //           return contacts
  //     }else {
  //       return response;
  //     }
  //   }else {
  //     return response;
  //   }
  // }
  // const updateRosterData = async (pageNumber = 1, searchText = "") => {
  //   setForwardPopUpState({
  //   ...forwardPopUpState,      
  //   userList: [...userList,...await getUsersListSDK(pageNumber,searchText)],
  //   isContactFetch: true  
  //   });
  // }
// const createUserMessageColor = ( data = []) =>{
//   return data.map(contact=>{
//       return { 
//           ...contact,
//           userColor:mapColorForTouser()
//       }
//   })
// }

// const RosterDataUpsert = (data, pageNumber) => { 
//   const getcurrentState = store.getState()
//   const promise = new Promise((resolve,reject) =>{
//     setForwardPopUpState({
//       ...forwardPopUpState,
//       user
//     })
//       store.dispatch(rosterDataUpsert({
//           id: uuidv4(),
//           data:createUserMessageColor(data),
//           pageNumber: pageNumber
//       }));
//      resolve(true) 
//   })
//   const rosterId = getcurrentState?.rosterData?.id
//   if(rosterId) return
//   promise.then(async (res)=> {
//       // const userIBlockedRes = await SDK.getUsersIBlocked();
//       // if(userIBlockedRes && userIBlockedRes.statusCode === 200){
//       //     const jidArr = formatToArrayofJid(userIBlockedRes.data);
//       //     Store.dispatch(blockedContactAction(jidArr));
//       // }
//       // const userBlockedMeRes = await SDK.getUsersWhoBlockedMe();
//       // if(userBlockedMeRes && userBlockedMeRes.statusCode === 200){
//       //     const jidArr = formatToArrayofJid(userBlockedMeRes.data);
//       //     setContactWhoBleckedMe(jidArr);
//       // }
//   });
// };    
*/

  const addContact = (jid, userName, updateJid) => {
    setForwardPopUpState({
      ...forwardPopUpState,
      contactsToForward: contactsToForward.concat(jid),
      contactsToDisplay: contactsToDisplay.concat(userName),
      jidArray: jidArray.concat(updateJid),
      unBlockedUserName: unBlockedUserName.concat(userName)
    });
  };

  const removeContact = (jid, userName, updateJid) => {
    setForwardPopUpState({
      ...forwardPopUpState,
      contactsToForward: contactsToForward.filter((user) => user !== jid),
      contactsToDisplay: contactsToDisplay.filter((user) => user !== userName),
      jidArray: jidArray.filter((user) => user !== updateJid),
      unBlockedUserName: unBlockedUserName.filter((user) => user !== userName)
    });
  };

  const recentChatSearchFilter = (searchWith) => {
    const { data } = recentChatItems;
    return data.filter((item) => {
      const { roster, recent } = item;
      if (roster.isDeletedUser) return false;
      const { existGroup } = roster;
      const { leftGroup } = recent;
      if (existGroup || leftGroup) return false;

      const regexList = getUserInfoForSearch(roster);
      return regexList.find((str) => {
        if (!str) return false;
        return str.search(new RegExp(searchWith, "i")) !== -1;
      });
    });
  };

  const contactsSearch = (searchTerm) => {
    const { rosterData: { recentChatNames: recentNames } } = recentChatData;
    const { data: contactData } = rosterData;
    if (!contactData) return [];
    return handleFilterBlockedContact(contactData).filter((item) => {
      const userJid = item.username ? item.username : item.userId;
      if (recentNames.indexOf(userJid) > -1) {
        return false;
      }
      const regex = getUserInfoForSearch(item);
      return regex.find((str) => {
        if (!item.isFriend || !str) return false;
        return str.search(new RegExp(searchTerm, "i")) !== -1;
      });
    });
  };

  const initialLoad = async(searchWith = "", searchValueInitialLoad = "") => {
    const updatedList = recentChatSearchFilter(searchWith).filter(item => (item?.roster?.isAdminBlocked !== true && item?.roster?.isDeletedUser !== true && item?.recent?.profileUpdatedStatus !== "userLeft"));
    setfilteredRecentChat(updatedList)
    const filteredContactsInitialLoad = contactsSearch(searchWith);
    let filteredRecentNames = updatedList.map((item, key) => (
      item?.roster?.name || item?.roster?.groupName
    ))
    let filteredContactNames = filteredContactsInitialLoad.map((item, key) => (
      item?.name
    ))
    let allContactList = [...filteredRecentNames, ...filteredContactNames]
    let adminContactsToDisplay = [];
    let adminContactsToForward = contactsToForward
    let adminJidArray = jidArray
    let adminUnBlockedUserName = unBlockedUserName

    contactsToDisplay.map((item, key) => {
      if (allContactList.includes(item)) {
        adminContactsToDisplay.push(item)
      } else {
        adminContactsToForward.splice(key, 1)
      }
    })
    adminUnBlockedUserName.map((item, key) => {
      if (allContactList.includes(item) && !adminContactsToDisplay.includes(item)) {
        adminContactsToDisplay.push(item)
        adminContactsToForward.push(adminJidArray[key])
      }
    })
    if(isContactFetch){
      setForwardPopUpState({
        ...forwardPopUpState,
        isContactFetch:false
      });
      return
    }
    // let  contacts = await getUsersListSDK(1)
    setForwardPopUpState({
      ...forwardPopUpState,
      searchValue: searchValueInitialLoad,
      // filteredRecentChat: updatedList,
      filteredContacts: filteredContactsInitialLoad,
      // userList: contacts,
      // loaderStatus: isContactFetch,
      contactsToDisplay: adminContactsToDisplay,
      contactsToForward: adminContactsToForward,
      isContactFetch:false
    });
    
  };
/**
//   const searchFilterList = (searchValues) => {
//     const searchedValue = getValidSearchVal(searchValues);
//     let searchWith = searchedValue;
//     const filteredContactts = contactsSearcher(searchWith)
//     getUsersListFromSDK(1, searchWith);
//     setForwardPopUpState({...forwardPopUpState,
//         searchValue: searchedValue,
//         errorMesage: '',
//         filteredContacts: filteredContactts,        
//         loaderStatus: false
//     });
//     setForwardContact({...forwardContact, userLister: filteredContactts})
//     // getUsersListFromSDK(1, searchWith);
// }
*/

  const searchFilterList = async (searchingValue) => {
    setForwardPopUpState({
      ...forwardPopUpState,             
      loaderStatus: !isContactFetch,              
    });
      const searchedValue = getValidSearchVal(searchingValue);
      let searchWith = searchedValue;
      let filteredContactts = contactsSearch(searchWith)
      const updatedList = recentChatSearchFilter(searchWith).filter(item => 
        (item?.roster?.isAdminBlocked !== true && 
          item?.roster?.isDeletedUser !== true && 
          item?.recent?.profileUpdatedStatus !== "userLeft"));
          getUsersListFromSDK(1, searchWith)
          setfilteredRecentChat(updatedList)
      setForwardPopUpState({
        ...forwardPopUpState,
        searchValue: searchedValue,
        // filteredRecentChat: updatedList,
        filteredContacts: filteredContactts,
        // userList: contacts,
        loaderStatus: isContactFetch,
      });
  };

  const findLastChat = (contactsToForward = "") => {
    const { recentChatItems: { data = [] } = {} } = globalState || {};
    const findUser = data.filter((ele) => _get(ele, "roster.userJid") === contactsToForward.toString());
    const findGrp = data.filter((ele) => _get(ele, "roster.groupId") === contactsToForward.split("@")[0].toString());
    if (findUser.length === 0 && findGrp.length === 0) {
      const newRoster = getDataFromRoster(getUserIdFromJid(contactsToForward));
      return [{ roster: newRoster, recent: { chatType: CHAT_TYPE_SINGLE } }];
    }
    return [...findUser, ...findGrp];
  };

  const handleUpdateHistory = (toJid, contactsToForwards, originalMsg, newMsgIds, msdIdIndex) => {
    setTimeout(() => {
      const conversationHistory = getChatHistoryMessagesData();
      if (
        Object.keys(conversationHistory).includes(getUserIdFromJid(toJid)) ||
        contactsToForward[contactsToForwards.length - 1] === toJid
      ) {
        const dataMsg = getMessageObjForward(originalMsg, toJid, newMsgIds[msdIdIndex]);
        const dispatchData = {
          data: [JSON.parse(JSON.stringify(dataMsg))],
          ...(isSingleChatJID(toJid) ? { userJid: toJid } : { groupJid: toJid })
        };
        store.dispatch(addChatConversationHistory(dispatchData));
        store.dispatch(addPendindMedia(dispatchData));
      }
    })
    };

  const sendForwardMessage = async () => {
    if (!isAppOnline) {
      toast.error(NO_INTERNET)
      blockOfflineAction();
      return;
    }
    const { data } = selectedMessageData;
    let msgIds = data.slice().sort((a, b) => (b.timestamp > a.timestamp ? -1 : 1)).map((el) => el.msgId);
    let newMsgIds = [];
    let totalLength = data.length * contactsToForward.length;
    for (let i = 0; i < totalLength; i++) newMsgIds.push(uuidv4());  
    SDK.forwardMessagesToMultipleUsers(contactsToForward, msgIds, true, newMsgIds);

    const chatToOpen = contactsToForward[contactsToForward.length - 1];
    const responses = findLastChat(chatToOpen);
    const { recent: { chatType } } = responses[0];
    const chatId = getUserIdFromJid(chatToOpen)
    if (chatType) {
      let datas = {
        "chatId" : chatId,
        "chatJid" : chatToOpen,
        "chatType" : chatType,
        "recent": responses[0]?.recent,
        "roster": responses[0]?.roster
      }
      store.dispatch(addActiveChatData(datas));
    }
    /**
    // const activeData = await constructedActiveChatData(chatToOpen,chatType)
    // store.dispatch(addActiveChatData(activeData));
    */
   
    let msdIdIndex = 0;
      for (let i of msgIds)
        for (let j of contactsToForward) {
          const oldMsgId = i;
          const originalMsg = getMessageFromHistoryById(props.activeJid, oldMsgId);
          const toJid = j;
          const recentChatObj = await getRecentChatMsgObjForward(originalMsg, toJid, newMsgIds[msdIdIndex]);
          await store.dispatch(updateRecentChat(recentChatObj));
          handleUpdateHistory(toJid, contactsToForward, originalMsg, newMsgIds, msdIdIndex);
          // // if (i === 0) handleTempArchivedChats(toJid, originalMsg.chatType);
          msdIdIndex++;
    }
    scrollToBottom();
    // closeMessageOption;
  };  
  
  const handleUserListData = () => {
    let dataArr = [];
    let rosterName = filteredRecentChat.map((contact) => {
      const { roster } = contact;
      return roster.name
    })
    if (userLister.length > 0) {
      userLister.map((contact) => {
      let checkName = rosterName.includes(contact.name)
      const { username, userId } = contact;
      if(!checkName) {
        const contactName = getContactNameFromRoster(contact);
        const updateJid = userId || username;
        const isChanged = jidArray.findIndex((jid) => jid === updateJid);
        const blockedContactArr = blockedContact?.data;
        const isBlockedUser =
          blockedContactArr.indexOf(
            updateJid.includes("@") ? updateJid : updateJid + "@" + REACT_APP_XMPP_SOCKET_HOST
          ) > -1;        
        dataArr.push(
          <li key={updateJid} className={`chat-list-li ${isBlockedUser ? "Blocked" : ""}`}>
            <Users
              key={updateJid}
              isBlockedUser={isBlockedUser}
              searchValue={searchValue}
              contactName={contactName}
              addContact={addContact}
              updateJid={updateJid}
              temporary={false}
              isChanged={isChanged}
              selectedContact={contactsToForward.length}
              chatType={"chat"}
              removeContact={removeContact}
              roster={contact}
              {...contact}
            />
          </li>
        )
      }else {
        return
      }
    });
    }
    return dataArr;
  }

  const fetchMoreData = () => {
    if(isAppOnline) {
      let searchWith = getValidSearchVal(searchValue);
      getUsersListFromSDK(Math.ceil((userListArr.length / 20) + 1), searchWith)
        setForwardPopUpState({
          ...forwardPopUpState,
          loaderStatus: !isContactFetch
        });  
    }  
  }

  const usersName = contactsToDisplay.join(", ");
  const messageLength =
    (selectedMessageData &&
      Array.isArray(selectedMessageData?.data) &&
      selectedMessageData?.data.length) ||
    0;
  const userListArr = handleUserListData();
  return (
    <React.Fragment>
      <div className="popup-wrapper">
        <div className="popup-container add-participant forward">
          <div className="popup-container-inner">
            <div className="popup-container-header">
              {/* <i onClick={closePopup} className="closePopup"> */}
              <i onClick={closeMessageOption} className="closePopup">
                <Close2Hoc />
              </i>
              <h5>Forward message{messageLength > 1 ? "s" : ""} to</h5>
            </div>
            <RecentSearch search={searchFilterList} />
            <div className="popup-body" style={{ overflow: "hidden" }}>
              <div className="contactList" style={{ height: "100%" }}>
                <ul className="chat-list-ul" style={{ height: "100%" }} id="scrollableUl-forward">
                  {loaderStatus && isAppOnline &&<div className="response_loader style-2">
                    <img src={loaderSVG} alt="loader" />
                  </div>
                  }

                  {filteredContacts.length === 0 && filteredRecentChat.length === 0 &&
                  searchValue && !loaderStatus &&
                    <span className="searchErrorMsg"><InfoHoc viewBox="0 0 8.683 8.683"/>
                      {NO_RESULTS_FOUND}
                    </span>}
                  {(userListArr.length > 0 || filteredRecentChat.length > 0) &&
                    <InfiniteScroll
                      dataLength={userListArr.length}
                      next={fetchMoreData}
                      hasMore={true}
                      scrollableTarget="scrollableUl-forward"
                    >
                      <li className="list-heading">Recent Chat</li>
                      {filteredRecentChat.map((contact) => {
                        const { roster, recent } = contact;
                        const { fromUserId: recentChatMesasge } = recent;
                        const chatType = contact?.recent?.chatType;
                        const { userId } = roster;
                        const contactName = getContactNameFromRoster(roster) || recentChatMesasge;
                        const updateJid = userId || recentChatMesasge;
                        const isChanged = jidArray.findIndex((jid) => jid === updateJid);
                        const blockedContactArr = blockedContact.data;
                        const isBlockedUser =
                          blockedContactArr.indexOf(
                            updateJid.includes("@") ? updateJid : updateJid + "@" + REACT_APP_XMPP_SOCKET_HOST
                          ) > -1;
                        return (
                          <li key={updateJid} className={`chat-list-li ${isBlockedUser ? "Blocked" : ""}`}>
                            <Users
                              isBlockedUser={isBlockedUser}
                              searchValue={searchValue}
                              contactName={contactName}
                              temporary={false}
                              addContact={addContact}
                              updateJid={updateJid}
                              chatType={chatType}
                              isChanged={isChanged}
                              selectedContact={contactsToForward.length}
                              removeContact={removeContact}
                              roster={roster}
                              {...roster}
                            />
                          </li>
                        );
                      })}
                      <li className="list-heading">Contacts</li>

                      {handleUserListData()}

                    </InfiniteScroll>
                  }
                </ul>
              </div>
            </div>
            <div className="popup-footer">
              {/*
                 * When user select forward person will show send button
                 * Otherwise hide send button
                 */}
              {usersName.length !== 0 ? (
                <>
                  <i title="send" onClick={()=>{sendForwardMessage(); closeMessageOption()}} className="SendMessage">
                    <SendMessageHoc viewBox = "0 0 18.129 15.539" />
                  </i>
                </>
              ) : null}

              <div className="selectedList">
                <span title={usersName} className="">
                  {
                    // usersName.length > maximumCharForwardPopUp ? usersName.substring(0, maximumCharForwardPopUp).concat('...') : usersName
                    usersName
                  }
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ForwardPopUp;